import {useMutation, useQuery} from '@tanstack/react-query';
import {getCurrentUserRoleForEntity, getUsersAndRolesForEntity, removeUserRoleFromEntity} from '../endpoints/api';

export enum EntityRole {
  MANAGER = 1,
  TEAM_MEMBER = 2,
}

export function useGetUsersAndRolesForEntity(entity: string, entityId: number) {
  return useQuery(
    ['usersAndRolesForEntity', entity, entityId],
    () => getUsersAndRolesForEntity(entity, entityId),
    { enabled: !!entityId && !!entity }
  );
}

export function useGetCurrentUserRoleForEntity(entity: string, entityId: number) {
  return useQuery(
    ['currentUserRoleForEntity', entity, entityId],
    () => getCurrentUserRoleForEntity(entity, entityId),
    { enabled: !!entityId && !!entity }
  );
}